<script setup lang="ts">
const emit = defineEmits(["close"]);
const { createAuthAttemptAndRedirect } = useAuthController();
const router = useRouter();

const openOAuth = (type: string) => {
  createAuthAttemptAndRedirect(type);
  emit("close");
};

const handleClose = () => {
  router.push({ query: {} });
  emit("close");
};

onMounted(() => {
  useUserStore().logOut();
});
</script>
<template>
  <BaseLayoutModal width="medium" @close="handleClose" @mouse-up="handleClose">
    <template #header>
      <p class="">Login Unsuccessful</p>
    </template>
    <template #content>
      <div class="flex flex-col gap-2">
        <p class="text-neutral-300 font-light">
          An error has ocurred and we were unable to log you into your account.
          Please try again using the links below.
        </p>
        <p class="text-neutral-300 font-light">
          If the issue persists, please contact support.
        </p>
      </div>
      <div class="mt-5 mb-2 sm:mt-6 flex">
        <div class="flex flex-col gap-4">
          <div class="flex items-center gap-4">
            <BaseButtonSubmit
              class="w-44"
              data-test="button-login"
              @click="openOAuth('login')">
              <template #text>
                <span class="text-lg">{{
                  $t("main.modalBuyLogin.login")
                }}</span>
              </template>
            </BaseButtonSubmit>
            <BaseButtonCancel
              data-test="button-login-cancel"
              @click="handleClose">
              <template #text>
                <span class="text-lg">{{
                  $t("main.modalBuyLogin.cancel")
                }}</span>
              </template>
            </BaseButtonCancel>
          </div>
          <div class="flex gap-1">
            <p class="text-neutral-200">
              {{ $t("main.modalBuyLogin.notRegisteredYet") }}
            </p>
            <p
              @click="openOAuth('signup')"
              class="text-primary-500 cursor-pointer">
              {{ $t("main.modalBuyLogin.signUp") }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </BaseLayoutModal>
</template>
